import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PlateOption } from '@paragon/contract-library';

type PlateOptionsState =
  | { readonly state: 'pending' }
  | { readonly state: 'loading' }
  | { readonly state: 'loaded'; readonly data: readonly PlateOption[] }
  | { readonly state: 'error'; readonly message: string };

const initialState: PlateOptionsState = { state: 'pending' };

const plateOptionsSlice = createSlice({
  name: 'plateOptions',
  initialState: initialState as PlateOptionsState,
  reducers: {
    plateOptionsStartedLoading: () => ({ state: 'loading' as const }),
    plateOptionsFailedLoading: (_, action: PayloadAction<string>) => ({ state: 'error', message: action.payload }),
    plateOptionsFinishedLoading: (_, action: PayloadAction<readonly PlateOption[]>) => ({
      state: 'loaded',
      data: action.payload,
    }),
  },
});

export const { plateOptionsStartedLoading, plateOptionsFailedLoading, plateOptionsFinishedLoading } =
  plateOptionsSlice.actions;
export const plateOptions = plateOptionsSlice.reducer;
